import { render } from "./EditorQuestion.vue?vue&type=template&id=765554d4&scoped=true&bindings={}"
import script from "./EditorQuestion.vue?vue&type=script&lang=js"
export * from "./EditorQuestion.vue?vue&type=script&lang=js"

import "./EditorQuestion.vue?vue&type=style&index=0&id=765554d4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-765554d4"

export default script